import React from 'react';
import { Typography, Grid, Card, CardContent, CardActionArea, Box, Container, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Placeholder képek (mivel még nincsenek specifikus kategória képek, a meglévőket használjuk vagy színes boxokat)
import realEstateImg from '../../Assets/property.png';
import carImg from '../../Assets/autok.png';
import winterImg from '../../Assets/teli.png';
import summerImg from '../../Assets/nyari.png';
import produceImg from '../../Assets/sajattermek.png';
import producerImg from '../../Assets/helyitermelo.png';

function Market() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const produceCategories = [
    {
      id: 'own-produce',
      title: t('SubMenu.OwnProduce'),
      path: '/sajat-termeny',
      image: produceImg,
      description: t('Market.OwnProduceDesc', 'Helyi termelők élelmiszerei és kézműves termékei.')
    },
    {
      id: 'producers',
      title: t('Market.Producers', 'Helyi termelők'),
      path: '/termelok',
      image: producerImg,
      description: t('Market.ProducersDesc', 'Ismerje meg a környék gazdáit és kézműveseit.')
    }
  ];

  const usedGoodsCategories = [
    {
      id: 'real-estate',
      title: t('SubMenu.Property'),
      path: '/all-property-listings',
      image: realEstateImg,
      description: t('Market.RealEstateDesc', 'Ingatlanok eladása és kiadása Székelyföldön.')
    },
    {
      id: 'cars',
      title: t('SubMenu.Car'),
      path: '/all-car-listings',
      image: carImg,
      description: t('Market.CarsDesc', 'Gépjárművek adásvétele.')
    },
    {
      id: 'winter-sports',
      title: t('SubMenu.WinterSports'),
      path: '/teli-sportfelszereles',
      image: winterImg,
      description: t('Market.WinterSportsDesc', 'Sílécek, snowboardok és egyéb téli eszközök.')
    },
    {
      id: 'summer-sports',
      title: t('SubMenu.SummerSports'),
      path: '/nyari-sportfelszereles',
      image: summerImg,
      description: t('Market.SummerSportsDesc', 'Kerékpárok, túrafelszerelések és nyári sporteszközök.')
    }
  ];

  const CategoryCard = ({ cat }) => (
    <Grid item xs={12} sm={6} md={4} key={cat.id}>
      <Card sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        height: '100%',
        transition: 'transform 0.2s',
        '&:hover': { transform: 'scale(1.02)', boxShadow: 6 }
      }}>
        <CardActionArea 
          onClick={() => navigate(cat.path)}
          sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
        >
          <Box sx={{ height: '240px', overflow: 'hidden' }}>
            <img 
              src={cat.image} 
              alt={cat.title} 
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Box>
          <CardContent sx={{ flexGrow: 1 }}>
            <Typography variant="h5" component="h2" sx={{ color: '#105b79', fontWeight: 'bold' }}>
              {cat.title}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, sm: 2 }, mt: '100px' }}>
      <Typography variant="h3" align="center" gutterBottom sx={{ color: '#105b79', fontWeight: 'bold', mb: 4 }}>
        {t('Header.Piacter')}
      </Typography>

      {/* Top Block: Own Produce & Producers */}
      <Box sx={{ mb: 6 }}>
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, borderBottom: '2px solid green', pb: 1 }}>
            <Typography variant="h4" sx={{ color: 'green', fontWeight: 'bold' }}>
            {t('Market.LocalProductsBlock', 'Saját termény és helyi termelők')}
            </Typography>
            <Button 
                variant="contained" 
                onClick={() => navigate('/sajat-termeny-hozzaadasa')}
                sx={{ bgcolor: 'green', '&:hover': { bgcolor: 'darkgreen' } }}
            >
                {t('Accommodation.RegisterAsProducer', 'Jelentkezés helyi termelőként')}
            </Button>
        </Box>
        <Grid container spacing={3}>
          {produceCategories.map((cat) => (
            <CategoryCard key={cat.id} cat={cat} />
          ))}
        </Grid>
      </Box>

      {/* Bottom Block: Used Goods */}
      <Box>
        <Typography variant="h4" sx={{ color: '#105b79', fontWeight: 'bold', mb: 3, borderBottom: '2px solid #105b79', pb: 1 }}>
          {t('Market.UsedGoodsBlock', 'Használt cikkek')}
        </Typography>
        <Grid container spacing={3}>
          {usedGoodsCategories.map((cat) => (
            <CategoryCard key={cat.id} cat={cat} />
          ))}
        </Grid>
      </Box>
    </Container>
  );
}

export default Market;
